export default __webpack_public_path__ + "static/media/list.eab862e6.svg";